<template>
  <fragment v-if="isLoaded">
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Администрирование</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content">
          <br />
          <div class="administration-page-container">
            <div
              class="administration-page__item"
              v-for="(item, index) in adminList.items"
              :key="index"
            >
<!--              <router-link
                :to="{ path: `/admin/${item.PUNCT_CODE}` }"
                class="administration-page__item-link"
              >
                {{ item.PUNCT_NAME }}
              </router-link>-->
              <span   class="administration-page__item-link" style="text-decoration: none;">{{ item.PUNCT_NAME }}</span>
              <div class="administration-page__item-sub">
                <router-link
                  v-for="(subitem, idx) in item.CHILD"
                  :key="idx"
                  :to="{ path: `/admin/${subitem.PUNCT_CODE}` }"
                  class="administration-page__item-sub-link"
                >
                  {{ subitem.PUNCT_NAME }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_LIST,
  FETCH_DIRECTORIES,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

export default {
  title: "Администрирование",
  components: {
    Pagination,
    Datepicker,
    Multiselect
  },
  data() {
    return {
      siteUrl: "",
      isLoaded: false
    };
  },
  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.isEdit = data.IS_REDACT_GROUP_ORG;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });

          this.isLoaded = true;
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
          this.isLoaded = true;
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    this.$store.dispatch(FETCH_DIRECTORIES, [
      "hl/request_status",
      "hl/request_type"
    ]);
    ProjectsService.getListProjectsForRequest().then(({ data }) => {
      this.projects = data.items;
      this.loadProjectsList = true;
    });
    this.fetchList();
  },
  computed: {
    ...mapGetters(["adminList"]),
    listConfig() {
      return {};
    },
    pages() {
      if (
        this.isRequestsLoading ||
        !this.requests.counts ||
        this.requests.counts <= this.itemsPerPage
      ) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.requests.counts / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    }
  },
  watch: {},
  methods: {
    fetchList() {
      this.$store.dispatch(FETCH_ADMIN_LIST, this.listConfig).then(() => {
        //this.statuses = this.directory.hl_request_status;
        this.statusRendered = true;
       /* this.initiators = this.requests.DEFAULT_SETTINGS.INITIATOR_LIST;
        this.initiatorRendered = true;
        this.performers = this.requests.DEFAULT_SETTINGS.PERFORMER_LIST;
        this.performerRendered = true;

        this.organizations = this.requests.DEFAULT_SETTINGS.ORG_LIST;
        this.isOrgLoading = true;

        if (!this.filter.status.ID) {
          this.filter.status = this.statuses[0];
        }
        if (!this.filter.performer.ID) {
          this.filter.performer = this.requests.DEFAULT_SETTINGS.UF_PERFORMER_USER;
        }*/
      });
    }
  }
};
</script>
